import React from 'react'
import Box from "@mui/material/Box";

export default function Bull(props:any) {
  return (
    <Box
    component="span"
    sx={{ display: "inline-block", mx: "6px", transform: `${props.scale}`,mt:'2px',color:`${props.color}`,paddingTop:'5px',paddingLeft:'3px' }}
  >
    •
  </Box>
  )
}
